export const ENABLE_POTIC_RETAINER_TYPE = [
    'ecodontRetainers',
    'bleachingRetainers',
    'basicRetainers',
    'fixedPalatalWire',
    'ecodontRetainersWithWire',
    'ecodontRetainer_1set',
    'ecodontRetainerWithWire_1set',
];

export const ENABLE_CLEAR_DESIGN_QUESTION = [
    'ecodontRetainers',
    // 'ecodontRetainersWithWire' ,
    // 'MDLSmartFitRetainersWithWire' ,
    // 'fixedPalatalWire' ,
    'bleachingRetainers',
    'basicRetainers',
    'MDLSmartFitRetainers',
    'ecodontRetainer_1set',
];

// export const ENABLE_CLEAR_DESIGN_QUESTION_FOR_SECOND_SET = [
//     'ecodontRetainers',
//     // 'clearRetainer'
// ]

export const ENABLE_OCC_BITE_RAMP_QUESTION = ['MDLSmartFitRetainers', 'MDLSmartFitRetainersWithWire'];
export const ENABLE_Veneer_Shield_QUESTION = ['ecodontRetainerWithVeneerShield_3set', 'ecodontRetainerWithVeneerShield_1set'];

/**
 * 根据固定舌侧/腭侧丝状态返回需要显示保持器设计问题的保持器类型。
 */
export const getEnableClearDesignQuestionList = (hasWire, isForSecondSet = false) => {
    if (hasWire === 'false') return [];
    // const targetList = isForSecondSet ? ENABLE_CLEAR_DESIGN_QUESTION_FOR_SECOND_SET : ENABLE_CLEAR_DESIGN_QUESTION
    return [...ENABLE_CLEAR_DESIGN_QUESTION, ...ENABLE_Veneer_Shield_QUESTION];
};

export const getEnableEcodontWireSelect = () => {
    return ['ecodontRetainersWithWire'];
};

export const getInitRetainerReq = (retainerId) => {
    return {
        retainer_request_id: retainerId,
        impression_type: null,
        upper_fixed_wire: 0,
        upper_retainer_type_id: null,
        upper_bleaching_retainers_select: null,
        upper_wire_select: null,
        upper_low_trimline_area_select_1: null,
        upper_low_trimline_area_select_3: null,
        upper_bite_ramp: [],
        upper_clear_retainer_design_upper_option: null,
        // "upper_clear_retainer_design_lower_option": null,
        // "upper_clear_retainer_design_upper_option_for_second_set": null,
        // "upper_clear_retainer_design_lower_option_for_second_set": null,
        upper_pontic: null,
        upper_pontic_color: null,
        lower_low_trimline_area_select_1: null,
        lower_low_trimline_area_select_3: null,
        lower_retainer_type_id: null,
        lower_fixed_wire: null,
        lower_bleaching_retainers_select: null,
        lower_wire_select: null,
        lower_jig_placement_select: null,
        lower_bite_ramp: [],
        // "lower_clear_retainer_design_upper_option": null,
        lower_clear_retainer_design_lower_option: null,
        // "lower_clear_retainer_design_upper_option_for_second_set": null,
        // "lower_clear_retainer_design_lower_option_for_second_set": null,
        lower_pontic: null,
        lower_pontic_color: null,
        use_latest_approved_treatment_plan: 0,
        is_case_created_after_all_delivered: 0,
        special_instruction: null,
    };
};

export const isRetainerEcodontOrClearRetainer = (selectedRetainer) => {
    return [
        'ecodontRetainers',
        // 'clearRetainer'
    ].includes(selectedRetainer);
};

export const baseImpressionOption = {
    enableUseLastApprovedTp: false,
    enableUseLastRetainerRequest: false,
};
